import { getCurrentLanguage as v } from "../../reactive/features/i18n/i18n.js";
var h;
((y) => {
  async function f(n, a, e = null) {
    var o, t, s, d, r, c, l, p, g;
    const i = await (await fetch(`${n}/shop-service/session/`, {
      method: "post",
      body: JSON.stringify({
        location_id: a.restaurant.id,
        settings: {
          address: {
            address: (o = a.restaurant) == null ? void 0 : o.address,
            latitude: (t = a.restaurant) == null ? void 0 : t.latitude,
            longitude: (s = a.restaurant) == null ? void 0 : s.longitude
          },
          language: v()
        },
        service: {
          type: a.service.type,
          now: a.service.now,
          ready_at: a.service.readyAt,
          number_people: (d = a.service) == null ? void 0 : d.numberPeople,
          channel: a.service.channel,
          source: a.service.source
        },
        delivery: {
          drop_off: {
            address: (r = a.place) == null ? void 0 : r.formattedAddress,
            address_extra: a.addressExtra,
            latitude: (c = a.place) == null ? void 0 : c.lat,
            longitude: (l = a.place) == null ? void 0 : l.long,
            full_address: JSON.stringify(((p = a.place) == null ? void 0 : p.addressComponents) ?? {})
          }
        },
        landing: {
          querystring: a.querystring ?? window.location.search
        },
        dine_in: {
          table_id: (g = a == null ? void 0 : a.dineIn) == null ? void 0 : g.tableId
        }
      })
    })).json();
    return e !== null && await fetch(`${n}/shop-service/session/authentication/${i.id}/`, {
      method: "put",
      headers: {
        "content-type": "application/json",
        authorization: `Token ${e}`
      }
    }), i;
  }
  y.createShopSession = f;
})(h || (h = {}));
export {
  h as ShopSessionAPI
};
//# sourceMappingURL=index.js.map
